import styles from '../globals/pages.module.scss'

import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { Loading } from 'notiflix'
import { apiErrors } from '../helpers/apiErrors'
import SignatureForm from '../components/signatureForm/main'

import { useUpdateClaimData } from '../claimProvider'

function SignDocuments() {
    const [resumeClaimData, setResumeClaimData] = useState<any>()
    const [requestingClaim, setRequestingClaim] = useState(false)
    const { token } = useParams()
    const updateClaim = useUpdateClaimData()

    useEffect(() => {
        console.log('COLLECT DATA....')

        if (!requestingClaim) {
            setRequestingClaim(true)

            axios
                .post(`${process.env.REACT_APP_API_RESUME_SIGNATURE_CLAIM}`, { token, leadOrigin: 'webform_MFC' })
                .then((response) => {
                    const resumeData = response.data
                    console.log('resumeData:', resumeData)
                    if (resumeData.success) {
                        setResumeClaimData(resumeData)
                        updateClaim(resumeData.claimData)
                    } else {
                        throw new Error('failed....')
                    }
                    // Loading.remove();
                })
                .catch((e) => {
                    console.log('error:', e)
                    Loading.remove()
                    if (e.response) {
                        const serverError = e.response.data
                        apiErrors(serverError)
                    } else {
                        apiErrors('unknown')
                    }
                })
        }
    }, [requestingClaim])

    return <div className={`${styles.pcpClaimFormContainer}`}>{resumeClaimData && <SignatureForm />}</div>
}

export default SignDocuments
